<template>
  <div>
    <div class="hide-on-print">
      <!-- Page Title -->
      <page-title 
        icon="fa fa-file-alt"
        main="Relatórios"
        sub="Carteira de Clientes"
      >
      </page-title>

      <!-- Filters -->
      <card>
        <div slot="header" class="row align-items-center">
          <div class="col">
            <h5 class="h3 mb-0">Filtros</h5>
            <h6 class="text-uppercase text-muted ls-1 mb-1">
              Configure quais dados deverão ser listados:
            </h6>
          </div>
        </div>

        <div class="row">
          <div class="col-md-3 col-sm-12">
            <anosafra-multiselect
              v-model="filter.anoSafra"
              label="Ano Safra"
            />
          </div>
          <div class="col-md-3 col-sm-12">
            <label class="form-control-label">Filial</label>
            <multiselect
              v-model="filter.branch"
              :options="branches"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
              placeholder="Selecionar Filial"
              :disabled="!filter.has_region"
              label="name"
              track-by="id"
            />
          </div>

          <div class="col-md-3 col-sm-12">
            <label class="form-control-label">Gerente Comercial</label>
            <multiselect
              v-model="filter.manager"
              :options="managers"
              :loading="isLoadingManager"
              placeholder="Selecionar Gerente Comercial"
              :disabled="!currentUser.is_admin && currentUser.is_manager || !filter.has_region"
              label="name"
              track-by="id"
            />
          </div>

          <div class="col-md-3 col-sm-12">
            <label class="form-control-label">Vendedor</label>
            <multiselect
              v-model="filter.salesman"
              :options="salesmen"
              :loading="isLoadingSalesmen"
              :disabled="!currentUser.is_admin && !currentUser.is_manager || !filter.has_region"
              label="name"
              placeholder="Selecionar Vendedor"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
              track-by="id"
              @search-change="initSalesmen"
            />
          </div>
          <div class="col-md-3 col-sm-12">
            <br />
            <base-switch
              v-model="filter.pendency"
              label="Possui pendencias?"
            ></base-switch>
          </div>
          <div class="col-md-3 col-sm-12">
            <br />
            <base-switch
              v-model="filter.has_region"
              label="Possui carteira?"
            ></base-switch>
          </div>
        </div>

        <div slot="footer" class="row justify-content-end mr-1">
          <base-button type="secondary" class="mr-2 mt-2" @click="clearFilters">Limpar Filtros</base-button>
          <base-button type="secondary" class="mr-2 mt-2" v-loading="isLoadingPdf" @click="generatePDF">Gerar PDF</base-button>
          <base-button type="secondary" class="mt-2"  @click="exportToExcel()">Gerar Excel</base-button>
           <base-button
            type="primary"
            @click="generateReport"
            class="ml-2 mt-2"
            v-loading="isLoading"
            >Gerar Relatório</base-button
          >
        </div>
      </card>
    </div>

    <card v-show="clients.length" ref="report">
      <div class="col hide-on-print">
        <h5 class="h3 mb-0">Relatório</h5>
        <h6 class="text-uppercase text-muted ls-1 mb-1">
          Clientes - {{ lastEdition | formatDate("full") }}
        </h6>
      </div>

      <div class="col print-only">
        <img
          :src="
            setting_image.logo_sgv && setting_image.logo_sgv.value ?
            setting_image.logo_sgv.value : '/img/brand/top-logo.png'
          "
          class="navbar-brand-img"
          style="
            width: 200px;
            display: block;
            margin-left: auto;
            margin-right: auto;
          "
        />
        <h5 class="h1 mb-0">Relatório</h5>
        <h6 class="h3 text-uppercase text-muted ls-1 mb-1">
          Clientes - {{ lastEdition | formatDate("full") }}
        </h6>
        <h6
          class="text-uppercase text-muted ls-1 mb-1"
          v-if="filter.anoSafra && Object.keys(filter.anoSafra).length"
        >
          Ano Safra: {{ filter.anoSafra.descricao }}
        </h6>
        <h6
          class="text-uppercase text-muted ls-1 mb-1"
          v-if="filter.branch && Object.keys(filter.branch).length"
        >
          Filial: {{ filter.branch.name }}
        </h6>
        <h6
          class="text-uppercase text-muted ls-1 mb-1"
          v-if="filter.manager && Object.keys(filter.manager).length"
        >
          Gerente Comercial: {{ filter.manager.name }}
        </h6>
        <h6
          class="text-uppercase text-muted ls-1 mb-1"
          v-if="filter.salesmen && Object.keys(filter.salesmen).length"
        >
          Vendedor: {{ filter.salesmen.name }}
        </h6>
        <br />
        <br />
        <br />
      </div>
      <el-table
        min-width="500px"
        :data="clients"
        class="table-responsive table-striped"
        header-row-class-name="thead-light"
      >
        <el-table-column label="Código" min-width="60px" prop="code" sortable />
        <el-table-column label="Nome" min-width="185px" prop="name" sortable />
        <el-table-column
          label="Região"
          min-width="120px"
          prop="region_name"
          sortable
        />
        <el-table-column
          label="Filial"
          min-width="135px"
          prop="branch_name"
          sortable
        />
        <el-table-column
          label="Vendedor"
          min-width="120px"
          prop="salesman_names"
          sortable
        />
        <el-table-column
          label="Gerente Comercial"
          min-width="120px"
          prop="manager_names"
          sortable
        />
      </el-table>
      <div slot="footer" class="py-4 d-flex justify-content-end">
        <base-pagination
          v-on:input="changePage"
          v-model="paginated_data['current']"
          :total="paginated_data['count']"
          :perPage="paginated_data['per_page']"
        ></base-pagination>
      </div>
    </card>
  </div>
</template>

<script>
import PageTitle from "@/layouts/PageTitle";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";
import AnosafraMultiselect from "@/components/Multiselect/anosafra_multiselect.vue";


import { Table, TableColumn } from "element-ui";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

export default {
  components: {
    PageTitle,
    Multiselect,
    AnosafraMultiselect,
    [TableColumn.name]: TableColumn,
    [Table.name]: Table,
  },
  data() {
    return {
      active: true,
      filter: {
        anoSafra: {},
        branch: {},
        manager: {},
        salesman: {},
        pendency: false,
        has_region: true,
      },
      paginated_data: [],
      salesmen: [],
      managers: [],
      branches: [],
      anoSafras: [],
      clients: [],
      lastEdition: new Date(),
      isLoadingManager: false,
      isLoadingSalesmen: false,
      isLoading: false,
      isLoadingPdf: false,
      currentUser: {}
    };
  },
  methods: {
    async generatePDF(q = null) {
      this.isLoadingPdf = true
      const data = {
        q: q || {},
      }

      if (this.filter.has_region) {
        if (this.filter.salesman) data["anosafra_users[salesman_id]"]  = this.filter.salesman.id
        if (this.filter.manager)  data["anosafra_users[manager_id]"]   = this.filter.manager.id
        if (this.filter.anoSafra) data["client_regions[anosafra_id]"]  = this.filter.anoSafra.id
        if (this.filter.branch)   data["regions[branch_id]"]           = this.filter.branch.id
        data.pendency = this.filter.pendency
      } else {
        if (this.filter.anoSafra) data["anosafra_id"] = this.filter.anoSafra.id
        data.has_region    = false
        data.pendency      = this.filter.pendency
        data.q.region_ids  = null
      }
      try {
        const response = await this.$http.secured.get("/api/v1/report/clients.pdf", { 
          params:{
            service_params: data,
          },
          responseType: "arraybuffer"
        })
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.target = "_blank";
        link.setAttribute(
          "download",
          `Clientes.pdf`
        );
        document.body.appendChild(link);
        link.click();
      } catch (error) {
        console.error('[Reports][Clients][GeneratePdf]', error)
        this.isLoadingPdf = false
      } finally {
        this.isLoadingPdf = false
      }
    },
    clearFilters() {
      this.filter.branch = {},
      this.filter.manager = {},
      this.filter.salesman = {}
    },
    exportToExcel() {
      return this.$exportToExcel();
    },
    async generateReport(q = null, page = null) {
      this.isLoading = true;

      const data = {
        page: page,
        q: q || {},
      }

      if(this.filter.has_region){
        if(this.filter.salesman) data["anosafra_users[salesman_id]"]  = this.filter.salesman.id
        if(this.filter.manager)  data["anosafra_users[manager_id]"]   = this.filter.manager.id
        if(this.filter.anoSafra) data["client_regions[anosafra_id]"]  = this.filter.anoSafra.id
        if(this.filter.branch)   data["regions[branch_id]"]           = this.filter.branch.id
        data.pendency = this.filter.pendency
      }else{
        if(this.filter.anoSafra) data["anosafra_id"]  = this.filter.anoSafra.id
        data.has_region    = false
        data.pendency      = this.filter.pendency
        data.q.region_ids  = null
      }

      try {
        const response = await this.$http.secured.get(`/api/v1/report/${this.filter.has_region ? 'clients' : 'clients_without_region'}`, { params: data })
        this.lastEdition = new Date();
        this.paginated_data = response.data;
        this.clients = this.paginated_data["clients"];
      } catch (error) {}

      this.isLoading = false;
    },
    initManagers(query) {
      this.isLoadingManager = true;
      var data = {
        q: { name: query, is_manager: true, status: this.active },
      };

      if(this.filter.anoSafra && this.filter.anoSafra.id)
        data.q['anosafra_id'] = this.filter.anoSafra.id

      this.$http.secured
        .get("/api/v1/users", { params: data })
        .then((response) => {
          this.managers = response.data.users || [];
          this.isLoadingManager = false;
        })
        .catch(() => {
          this.isLoadingManager = true;
        });
    },
    initSalesmen(query) {
      var data = {
        q: { name: query, is_salesman: true, status: this.active },
      };

      if (this.filter.manager && this.filter.manager.id)
        data.q["manager_id"] = this.filter.manager.id;
      if (this.filter.manager && this.filter.manager.coordinated_id)
        data.q["manager_id"] = this.filter.manager.coordinated_id;
      if (this.filter.anoSafra && this.filter.anoSafra.id)
        data.q["anosafra_id"] = this.filter.anoSafra.id;

      this.isLoadingSalesmen = true;
      this.$http.secured
        .get("/api/v1/users", { params: data })
        .then((response) => {
          this.isLoadingSalesmen = false;
          this.salesmen = response.data.users || [];
        })
        .catch(() => (this.isLoadingSalesmen = true));
    },
    initBranches() {
      this.$http.secured
        .get("/api/v1/branches")
        .then((response) => (this.branches = response.data));
    },
    changePage(page) {
      let filterInput = null;
      if (this.filtered) filterInput = this.filter;
      this.generateReport(filterInput, page);
    },
    findManagers(query) {
      var data = {
        q: { name: query, is_manager: true, status: this.active },
      };

      if (this.filter.anosafra && this.filter.anosafra.id)
        data.q["anosafra_id"] = this.filter.anosafra.id;

      this.$http.secured
        .get("/api/v1/users", { params: data })
        .then((response) => {
          this.filter.isLoadingManagers = false;
          this.filter.managers = response.data.users || [];
        })
        .catch(() => (this.filter.isLoadingManagers = false));
    },
  },
  mounted() {
    this.initBranches();

    this.currentUser = this.$currentUser();
    if (this.currentUser.is_manager) {
    }

    if (this.currentUser.is_manager && !this.currentUser.is_admin) {
        this.managers = [this.currentUser];
        this.salesmen = this.currentUser.salesmans;
        this.filter.manager = this.currentUser;
    } else if (this.currentUser.is_salesman && !this.currentUser.is_admin) {
        this.managers = [this.currentUser.manager];
        this.salesmen = [this.currentUser];
        this.filter.manager = this.currentUser.manager;
        this.filter.salesman = this.currentUser;
    }

    if(this.$can('index', 'user')){
      this.initSalesmen("");
    }
  },
  computed: {
    setting_image() {
      return this.$store.state.imageSettings || {}
    }
  },
  watch: {
    "filter.manager": function () {
      if(this.$can('index', 'user')){
        // this.initSalesmen("");
      }
    },
    "filter.anoSafra": function () {
      if(this.$can('index', 'user')){
        // this.initSalesmen("");
      }
      // this.initManagers("");
      // if(this.currentUser.is_admin){
      //   this.initManagers('')
      // }
    },
  },
};
</script>
